<template>
  <div class="hamburger" @click="toggleClick">
    <i class="el-icon-s-fold" />
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick')
    }
  }
}
</script>

<style scoped>
.hamburger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.hamburger:hover {
  background: rgba(255, 255, 255, 0.12);
}

.hamburger i {
  color: #fff;
  font-size: 20px;
  line-height: 1;
}
</style>
